import Tr from '@/i18n/translation';

export function getStringDate(
  date: Date,
  locale: string = Tr.currentLocale,
): string {
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}
